var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.classes,on:{"click":function($event){$event.stopPropagation();return _vm.select.apply(null, arguments)},"mousedown":function($event){$event.preventDefault();},"touchstart":function($event){$event.preventDefault();}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.showLabel))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }